import React, { useContext, useState } from "react";
import UserContext from "../context/UserContext";
import { SERVER_IP, ud, jwt } from "../Server";
import Swal from "sweetalert2";
import axios from "axios";
import { CloseIcon } from "../assets/Icons";

export default function FAQCreate() {
  const context = useContext(UserContext);
  const { updateddata, setUpdateddata } = context;

  const [inputdata, setInputdata] = useState({ title: "", description: "" });
  const onChange = (e) => {
    setInputdata({ ...inputdata, [e.target.name]: e.target.value });
  };

  const clickHandler = async (e) => {
    e.preventDefault();
    var data = { title: inputdata.title, description: inputdata.description };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    const result = await axios.post(`${SERVER_IP}/userfaq/create`, data, { withCredentials: true, headers: headers });
    setInputdata({ title: "", description: "" });
    if (result.data.error === false) {
      Swal.fire({
        title: "Success",
        text: result.msg,
        icon: "success",
        confirmButtonText: "Ok",
      });
      updateddata ? setUpdateddata(false) : setUpdateddata(true);
      document.getElementById("createModal").click();
    } else {
      Swal.fire({
        title: "Error",
        text: result.msg,
        icon: "error",
        confirmButtonText: "Ok",
      });
      document.getElementById("createModal").click();
    }
  };
  return (
    <>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header py-3 d-flex align-items-center  bg-light border-radius-top-15">
            <h5 className="modal-title" id="createModalLabel">
              Create FAQ
            </h5>
            <button id="createModal" type="button" className="close-s" data-dismiss="modal">
              <CloseIcon />{" "}
            </button>
          </div>

          <div className="container mb-3">
            <div className="row">
              <form className="col-sm-12 mt-3">
                <div className="card mb-3">
                  <div className="card-body">
                    <label htmlFor="Title">Title:</label>
                    <input
                      id="title"
                      type="text"
                      placeholder="Title:"
                      className="form-control mb-2"
                      name="title"
                      value={inputdata.title}
                      onChange={onChange}
                    />
                    <label htmlFor="Description">Description:</label>
                    <textarea
                      id="description"
                      placeholder="Description..."
                      className="form-control"
                      rows="3"
                      name="description"
                      value={inputdata.description}
                      onChange={onChange}
                    ></textarea>
                  </div>
                </div>
                <div className="px-3">
                  <button type="submit" className="btn btn-primary mr-4" onClick={clickHandler}>
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
